export default "__VITE_ASSET__CpqINX8C__"